import React                                    from 'react';
import { connect }                              from 'react-redux';
import { getTranslate }                         from 'react-localize-redux';
import ChangePasswordComponent                  from 'components/main/settings/changePassword';
import toolHelper                               from 'helpers/tools.helper';
import validationHelper                         from 'helpers/validation.helper';
import { editPassword }                         from 'actions/session/userAuth';

class ChangePassword extends React.Component {

  constructor() {
    super();

    this.state = {
      oldPassword: {
        value: '',
        visible: false
      },
      newPassword: {
        value: '',
        visible: false
      },
      newPasswordConfirmation: {
        value: '',
        visible: false
      },
      errors: [],
      isCapslock: false
    }
  }

  handleChange(key, e) {
    this.setState({[key]: { ...this.state[key], value: e.target.value } });
  }

  submitForm(e) {
    e.preventDefault();
    const { oldPassword, newPassword, newPasswordConfirmation } = this.state;
    const errors = this.checkErrors();
    this.setState({ errors: errors });

    if (!errors.length) {
      this.props.editPassword(oldPassword.value, newPassword.value, newPasswordConfirmation.value);
    };
  }

  checkCapsLock(e) {
    let isCapslock = toolHelper.isCapslock(e);
    this.setState({ isCapslock: isCapslock });
  }

  toggleVisible(type) {
    this.setState({ [type]: { ...this.state[type], visible: !this.state[type].visible } });
  }

  checkErrors() {
    const { newPassword, newPasswordConfirmation } = this.state;
    let errors = [];
    if (!validationHelper.passMatches(newPassword.value, newPasswordConfirmation.value)) {
      errors.push(this.props.translate('session.error.error_not_equal'));
    };

    if (validationHelper.passStrengthMeter(newPassword.value) < 3) {
      errors.push(this.props.translate('session.error.not_strong'));
    };
    return errors;
  }

  render() {
    const { translate, passwordUpdateStatus } = this.props;
    const { oldPassword, newPassword, newPasswordConfirmation, isCapslock, errors } = this.state;

    return (
      <React.Fragment>
        <ChangePasswordComponent
          translate={translate}
          oldPassword={oldPassword}
          newPassword={newPassword}
          newPasswordConfirmation={newPasswordConfirmation}
          handleChange={this.handleChange.bind(this)}
          toggleVisible={this.toggleVisible.bind(this)}
          checkCapsLock={this.checkCapsLock.bind(this)}
          isCapslock={isCapslock}
          submitForm={this.submitForm.bind(this)}
          passwordUpdateStatus={passwordUpdateStatus}
          errors={errors}
        />
      </React.Fragment>
    )
  }
};

const mapDispatchToProps = ({
  editPassword
});

const mapStateToProps = state => ({
  user: state.user,
  passwordUpdateStatus: state.user.passwordUpdateStatus,
  translate: getTranslate(state.locale)
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/containers/settings/changePassword.js